import commonEn from "./common.en";

const commonFr: Record<string, string> = {
  "merchant.uom.catalogUnavailable": "Le catalogue d’unités est indisponible.",
  "merchant.uom.conversionRequired": "Une conversion d’unité est requise.",
  "merchant.uom.baseProposal": "Utiliser {unit} comme unité de base pour {item} ?",
  "merchant.uom.confirmFailed": "Échec de la confirmation de l’unité de base.",
  "merchant.uom.confirm": "Confirmer",
  ...commonEn,
  "merchant.goods.review.compositionBridge": "Comparaison de référence de composition : le solde initial précédent reste figé. Elle ne modifie pas le stock et ne prouve aucune perte physique.",
  "merchant.goods.session.contentReference": "Référence du contenant / contenu distinct",
  "merchant.goods.session.physicalContentsOnce": "Comptez chaque contenu physique une seule fois : les matières premières et les préparations sont des objets distincts. La référence est votre déclaration, pas une reconnaissance automatique du contenu.",
  "publicContact.logoAlt": "Logo A3 Systems",
  "publicContact.call": "Appeler",
  "publicContact.email": "E-mail",
  "publicContact.website": "Site web",
  "publicContact.saveContact": "Enregistrer le contact",
  "waiter.tableDetail.header.backToTables": "← Tables",
  "waiter.tableDetail.header.guests": "Clients",
  "waiter.tableDetail.header.details": "Détails",
  "waiter.tableDetail.screen.add": "Ajouter",
  "waiter.tableDetail.screen.cart": "Panier",
  "waiter.tableDetail.screen.orders": "Commandes",
  "waiter.tableDetail.screen.requests": "Commandes / Demandes",
  "waiter.tableDetail.screen.more": "Plus",
  "waiter.tableDetail.add.search": "Rechercher",
  "waiter.tableDetail.add.searchAll": "Rechercher tous les plats",
  "waiter.tableDetail.help.title": "Un client demande de l'aide",
  "waiter.tableDetail.help.body": "Appeler le serveur",
  "waiter.tableDetail.help.requestedAt": "Appelé à {time}",
  "waiter.tableDetail.help.seen": "Vu",
  "waiter.tableDetail.reservation.title": "Réservation",
  "waiter.tableDetail.reservation.currentTable": "Cette table",
  "waiter.tableDetail.reservation.otherTables": "Autres tables",
  "waiter.tableDetail.reservation.cancel": "Annuler la réservation",
  "waiter.tableDetail.reservation.cancelShort": "Annuler",
  "waiter.tableDetail.reservation.cancelConfirmTitle": "Annuler la réservation ?",
  "waiter.tableDetail.reservation.cancelConfirmBody": "Cette réservation sera annulée pour le client.",
  "waiter.tableDetail.reservation.numberLabel": "Réservation",
  "waiter.tableDetail.reservation.tableDetailsLabel": "Table {table}",
  "waiter.tableDetail.reservation.cancelReasonLabel": "Motif d'annulation",
  "waiter.tableDetail.reservation.cancelReasonPlaceholder": "Choisir un motif",
  "waiter.tableDetail.reservation.cancelReasonRequiresText": "commentaire requis",
  "waiter.tableDetail.reservation.cancelReasonRequired": "Choisissez un motif d'annulation.",
  "waiter.tableDetail.reservation.canceled": "Réservation annulée.",
  "waiter.tableDetail.reservation.applyConfirmTitle": "Appliquer la réservation maintenant ?",
  "waiter.tableDetail.reservation.applyConfirmBody":
    "La réservation sera déplacée immédiatement vers cette table et l'horaire sera mis à jour.",
  "waiter.tableDetail.reservation.applyConfirmAction": "Appliquer la réservation",
  "waiter.tableDetail.reservation.syncPendingWarning":
    "Réservation appliquée localement, mais la synchronisation Restoplace doit être relancée.",
  "waiter.tableDetail.reservation.syncOverlapWarning":
    "Réservation appliquée localement, mais il y a un chevauchement avec une autre réservation dans Restoplace.",
  "waiter.tableDetail.occupy.now": "Occuper maintenant",
  "waiter.tableDetail.occupy.modalTitle": "Occuper la table",
  "waiter.tableDetail.occupy.confirmGuestPrompt": "Il y a une réservation active sur cette table. Est-ce votre client ?",
  "waiter.tableDetail.occupy.sameGuest": "Oui, même client",
  "waiter.tableDetail.occupy.differentGuest": "Non, autre client",
  "waiter.tableDetail.occupy.relocatePrompt":
    "Choisissez une table pour déplacer la réservation active, puis occupez cette table en walk-in.",
  "waiter.tableDetail.occupy.relocateTargetLabel": "Déplacer la réservation vers",
  "waiter.tableDetail.occupy.confirmRelocate": "Déplacer et occuper",
  "waiter.tableDetail.occupy.noActiveReservation":
    "Aucune réservation active trouvée. Occuper cette table comme walk-in maintenant ?",
  "waiter.tableDetail.occupy.success.noActive": "Table occupée en walk-in.",
  "waiter.tableDetail.occupy.success.matchExisting": "Réservation active mise à jour et table occupée.",
  "waiter.tableDetail.occupy.success.relocated": "Réservation déplacée vers une autre table et walk-in démarré.",
  "waiter.tableDetail.orders.openOrders": "Commandes ouvertes",
  "waiter.tableDetail.orders.newOrder": "Nouvelle commande",
  "waiter.tableDetail.orders.openedAt": "Ouvert {time}",
  "waiter.tableDetail.orders.openBill": "Note ouverte",
  "waiter.tableDetail.orders.paid": "Payé",
  "waiter.tableDetail.orders.remaining": "Reste",
  "waiter.tableDetail.orders.addGuestName": "Nom du client",
  "waiter.tableDetail.orders.locked": "Verrouillé",
  "waiter.tableDetail.queue.title": "File",
  "waiter.tableDetail.unsentCart.count": "Non envoyé au POS : {count} article(s)",
  "waiter.tableDetail.checkout.title": "Paiement",
  "waiter.tableDetail.checkout.statusPaid": "Payé",
  "waiter.tableDetail.checkout.statusPartiallyPaid": "Partiellement payé",
  "waiter.tableDetail.checkout.statusUnpaid": "Impayé",
  "waiter.tableDetail.checkout.addLanguageAge": "Ajouter langue / âge",
  "waiter.tableDetail.checkout.showQr": "Afficher QR",
  "waiter.tableDetail.checkout.printX": "Imprimer le check",
  "waiter.tableDetail.checkout.acceptCash": "Accepter espèces",
  "waiter.tableDetail.checkout.forceCloseDb.title": "Clôturer les commandes et libérer la table",
  "waiter.tableDetail.checkout.forceCloseDb.description":
    "Clôturer les commandes ouvertes de cette table, terminer la réservation active et libérer la table.",
  "waiter.tableDetail.checkout.forceCloseDb.warning":
    "Le POS n'est pas modifié. La libération dans Restoplace est tentée automatiquement.",
  "waiter.tableDetail.checkout.closeAllOpenOrders": "Clôturer les commandes et libérer la table",
  "waiter.tableDetail.checkout.forceCloseDb.confirm": "Clôturer et libérer",
  "waiter.tableDetail.checkout.forceCloseDb.closing": "Clôture…",
  "waiter.tableDetail.checkout.forceCloseDb.success": "{count} commande(s) locale(s) clôturée(s) et table libérée.",
  "waiter.tableDetail.checkout.forceCloseDb.empty": "Aucune commande locale ouverte restante. La libération de la table a quand même été tentée.",
  "waiter.tableDetail.checkout.forceCloseDb.error": "Échec de la clôture des commandes et de la libération de la table.",
  "waiter.tableDetail.action.add": "Ajouter",
  "waiter.tableDetail.action.addAll": "Tout ajouter",
  "waiter.tableDetail.action.reject": "Refuser",
  "waiter.tableDetail.action.rejectAll": "Tout refuser",
  "waiter.tableDetail.action.remove": "Retirer",
  "waiter.tableDetail.action.clear": "Effacer",
  "waiter.tableDetail.action.refresh": "Actualiser",
  "waiter.tableDetail.action.save": "Enregistrer",
  "waiter.tableDetail.action.back": "Retour",
  "waiter.tableDetail.action.cancel": "Annuler",
  "waiter.tableDetail.action.continue": "Continuer",
  "waiter.tableDetail.action.close": "Fermer",
  "waiter.tableDetail.common.loading": "Chargement…",
  "waiter.tableDetail.common.errorLabel": "Erreur:",
  "waiter.tableDetail.error.cancelReservation": "Impossible d'annuler la réservation",
  "waiter.tableDetail.error.loadOccupyPreview": "Impossible de charger l'aperçu d'occupation",
  "waiter.tableDetail.error.occupyTable": "Impossible d'occuper la table",
  "admin.aiModeration.generateDrafts.cta": "Generate AI Drafts",
  "admin.aiModeration.generateDrafts.running": "Generating…",
  "admin.aiModeration.generateDrafts.failed": "Failed to generate AI drafts",
  "admin.aiModeration.generateDrafts.generateOneCta": "Generate draft",
  "admin.aiModeration.generateDrafts.generateOneCompleted":
    "Draft generated: total={total}, persisted={persisted}, invalid={invalid}, failed={generationFailed}",
  "admin.aiModeration.generateDrafts.completed":
    "AI draft generation completed: total={total}, persisted={persisted}, invalid={invalid}, failed={generationFailed}",
  "admin.aiModeration.generateDrafts.summary":
    "Summary: total={total}, persisted={persisted}, invalid={invalid}, failed={generationFailed}",
  "admin.aiModeration.generateDrafts.regenerateOneCta": "Regenerate This Draft",
  "admin.aiModeration.generateDrafts.regenerateOneCompleted":
    "Draft regenerated: total={total}, persisted={persisted}, invalid={invalid}, failed={generationFailed}",
  "admin.aiModeration.generateDrafts.issuesTitle": "Items with validation/errors",
  "admin.aiModeration.generateDrafts.persistedWithValidationIssues": "Persisted with validation issues",
  "admin.aiModeration.queue.title": "AI moderation queue",
  "admin.aiModeration.queue.label": "Queue",
  "admin.aiModeration.queue.pending": "Pending",
  "admin.aiModeration.queue.aiGenerated": "AI generated",
  "admin.aiModeration.queue.approved": "Approved",
  "admin.aiModeration.queue.rejected": "Rejected",
  "admin.aiModeration.queue.all": "All",
  "admin.aiModeration.queue.refresh": "Refresh",
  "admin.aiModeration.queue.action": "Action",
  "admin.aiModeration.queue.review": "Review",
  "admin.aiModeration.queue.empty": "No AI profiles in this queue.",
  "admin.aiModeration.xlsx.exportCta": "Export AI XLSX",
  "admin.aiModeration.xlsx.importCta": "Import AI XLSX",
  "admin.aiModeration.xlsx.exported": "AI profiles XLSX exported",
  "admin.aiModeration.xlsx.exportFailed": "Failed to export AI profiles XLSX",
  "admin.aiModeration.xlsx.importFailed": "Failed to import AI profiles XLSX",
  "admin.aiModeration.modal.title": "AI profile moderation",
  "admin.aiModeration.modal.taxonomyRequired": "Canonical AI taxonomy (required for approval)",
  "admin.aiModeration.modal.canonicalCategoryKey": "Canonical category key",
  "admin.aiModeration.modal.selectCanonicalCategory": "Select canonical category",
  "admin.aiModeration.modal.canonicalTags": "Canonical tags",
  "admin.aiModeration.modal.canonicalTagsSearchPlaceholder": "Search canonical tags",
  "admin.aiModeration.modal.canonicalTagsEmpty": "No canonical tags selected yet.",
  "admin.aiModeration.modal.canonicalTagsNoResults": "No canonical tags match this search.",
  "admin.aiModeration.modal.rejectReason": "Reject reason (optional)",
  "admin.aiModeration.modal.rejectReasonPlaceholder": "Explain why AI draft is rejected",
  "admin.aiModeration.modal.cancel": "Cancel",
  "admin.aiModeration.modal.reject": "Reject",
  "admin.aiModeration.modal.approve": "Approve",
  "admin.aiModeration.modal.saveChanges": "Save changes",
  "admin.aiModeration.modal.suggestedFields": "Suggested fields",
  "admin.aiModeration.modal.suggestedFieldsEmpty": "Generate a draft to see AI suggestions for structured fields.",
  "admin.aiModeration.modal.useAiSuggestion": "Use AI suggestion",
  "admin.aiModeration.modal.useAllAiSuggestions": "Use all AI suggestions",
  "admin.aiModeration.modal.fieldColumn": "Field",
  "admin.aiModeration.modal.aiSuggestionColumn": "AI suggestion",
  "admin.aiModeration.modal.actionColumn": "Action",
  "admin.aiModeration.modal.auditTrail": "Audit trail",
  "admin.aiModeration.modal.auditEmpty": "No audit events yet.",
  "admin.aiModeration.modal.noProfileBadge": "No AI profile yet",
  "admin.aiModeration.modal.noProfileHelp": "Generate a draft to review AI classification for this item.",
  "admin.aiModeration.modal.draftHelp": "Review the draft, adjust taxonomy if needed, then approve or reject it.",
  "admin.aiModeration.modal.rejectedHelp": "This draft was rejected. Regenerate it or approve after manual correction.",
  "admin.aiModeration.modal.approvedHelp": "This item is approved. Adjust taxonomy values and save changes if needed.",
  "admin.aiModeration.modal.lastUpdated": "Last updated",
  "admin.aiModeration.modal.lastActor": "Last actor",
  "admin.aiModeration.modal.advanced": "Advanced",
  "admin.aiModeration.modal.aiProposed": "AI proposed",
  "admin.aiModeration.modal.approvedSnapshot": "Approved snapshot",
  "admin.aiModeration.modal.diff": "Diff: AI proposed vs approved",
  "admin.aiModeration.modal.approvedColumn": "Approved",
  "admin.aiModeration.opsTemplate.exportCta": "Export Ops Template",
  "admin.aiModeration.opsTemplate.importCta": "Import Ops XLSX",
  "admin.aiModeration.opsTemplate.exported": "Operational AI template exported",
  "admin.aiModeration.opsTemplate.exportFailed": "Failed to export operational AI template",
  "admin.aiModeration.opsTemplate.imported":
    "Operational AI import completed: created={created}, updated={updated}, unchanged={unchanged}",
  "admin.aiModeration.opsTemplate.importFailed": "Failed to import operational AI template",
  "admin.products.guestContent.title": "Guest-facing content",
  "admin.products.guestContent.nameEn": "Guest name EN",
  "admin.products.guestContent.nameLv": "Guest name LV",
  "admin.products.guestContent.nameRu": "Guest name RU",
  "admin.products.guestContent.nameFr": "Guest name FR",
  "admin.products.websiteDescription.title": "Website description",
  "admin.products.websiteDescription.help":
    "Shown on the merchant website and used as AI context when enrichment is enabled.",
  "admin.products.websiteDescription.en": "Website description EN",
  "admin.products.websiteDescription.lv": "Website description LV",
  "admin.products.websiteDescription.ru": "Website description RU",
  "admin.products.websiteDescription.fr": "Website description FR",
  "admin.products.websiteDescription.placeholder":
    "Write a factual storefront description: style, origin, aroma, taste, and serving context.",
  "admin.products.websiteDescription.approvedAiHint":
    "AI-approved products keep their current approved AI context until you regenerate and review a new draft manually.",
  "admin.products.descriptionState.empty": "Description empty",
  "admin.products.descriptionState.partial": "Description partial",
  "admin.products.descriptionState.complete": "Description complete",
  "admin.products.bulkDescriptions.copyToSelected": "Copy descriptions to selected ({count})",
  "admin.products.bulkDescriptions.copying": "Copying…",
  "admin.products.bulkDescriptions.copied": "Descriptions copied to {count} selected product(s)",
  "admin.products.bulkDescriptions.failed": "Failed to copy descriptions to selected products",
  "admin.products.bulkDescriptions.noTargets": "Select one or more other items to copy descriptions into.",
  "allergy.selector.label": "Allergies",
  "allergy.selector.hint": "Affiché sur les tickets cuisine et bar.",
  "allergy.gluten": "Céréales contenant du gluten",
  "merchant.staff.periodTitle": "Choisir la periode",
  "merchant.staff.periodBody": "Choisissez une periode rapide pour l'en-tete et la liste.",
  "merchant.staff.period.previous": "Periode precedente",
  "merchant.staff.period.next": "Periode suivante",
  "merchant.staff.period.today": "Aujourd'hui",
  "merchant.staff.period.yesterday": "Hier",
  "merchant.staff.period.tomorrow": "Demain",
  "merchant.staff.period.thisWeek": "Cette semaine",
  "merchant.staff.period.lastWeek": "Semaine derniere",
  "merchant.staff.period.nextWeek": "Semaine prochaine",
  "merchant.staff.period.thisMonth": "Ce mois-ci",
  "merchant.staff.period.lastMonth": "Mois dernier",
  "merchant.staff.period.nextMonth": "Mois prochain",
  "staff.portal.shiftSchedule": "Planning des services",
  "staff.portal.ready": "Pret",
  "staff.portal.schedule": "Planning",
  "staff.portal.teamMember": "Membre de l'equipe",
  "staff.portal.checkIn": "Arrivee",
  "staff.portal.checkOut": "Depart",
  "staff.portal.noShiftsAvailable": "Aucun service pour cette periode.",
  "staff.portal.shift.status.active": "En service",
  "staff.portal.shift.status.completed": "Termine",
  "staff.portal.shift.status.missed": "Manque",
  "staff.portal.shift.status.override": "Modifie",
  "staff.portal.shift.status.scheduled": "Planifie",
  "allergy.crustaceans": "Crustacés",
  "allergy.eggs": "Oeufs",
  "allergy.fish": "Poisson",
  "allergy.peanuts": "Arachides",
  "allergy.soybeans": "Soja",
  "allergy.milk": "Lait",
  "allergy.nuts": "Fruits à coque",
  "allergy.celery": "Céleri",
  "allergy.mustard": "Moutarde",
  "allergy.sesame": "Sésame",
  "allergy.sulphites": "Sulfites",
  "allergy.lupin": "Lupin",
  "allergy.molluscs": "Mollusques",
  "merchant.ap.view.reconciliation": "Rapprochement", "merchant.ap.reconciliation.loadError": "Impossible de charger la file de rapprochement.", "merchant.ap.reconciliation.permissionRequired": "L’autorisation de rapprochement est requise.", "merchant.ap.reconciliation.reason": "Motif de l’action", "merchant.ap.reconciliation.reasonRequired": "Saisissez un motif avant de continuer.", "merchant.ap.reconciliation.pendingApproval": "Envoyé à un autre utilisateur financier pour approbation.", "merchant.ap.reconciliation.applied": "Action de rapprochement appliquée.", "merchant.ap.reconciliation.actionError": "L’action n’a pas pu être appliquée. Actualisez et vérifiez les montants.", "merchant.ap.reconciliation.approvals": "En attente de contrôle", "merchant.ap.reconciliation.approve": "Approuver", "merchant.ap.reconciliation.reject": "Rejeter", "merchant.ap.reconciliation.empty": "Aucune opération bancaire à vérifier.", "merchant.ap.reconciliation.bankTransaction": "Opération bancaire", "merchant.ap.reconciliation.noCandidate": "Aucun paiement proposé trouvé", "merchant.ap.reconciliation.expected": "Attendu", "merchant.ap.reconciliation.booked": "Comptabilisé", "merchant.ap.reconciliation.confirm": "Confirmer", "merchant.ap.reconciliation.split": "Répartir", "merchant.ap.reconciliation.leave": "Laisser non rapproché", "merchant.ap.reconciliation.escalate": "Escalader", "merchant.ap.reconciliation.recentMatches": "Rapprochements manuels récents", "merchant.ap.reconciliation.reverse": "Annuler le rapprochement", "merchant.ap.reconciliation.counter.unmatchedBank": "Banque non rapprochée", "merchant.ap.reconciliation.counter.amountMismatch": "Écart de montant", "merchant.ap.reconciliation.counter.unknownPayment": "Paiement inconnu", "merchant.ap.reconciliation.counter.reversal": "Extourne", "merchant.ap.reconciliation.counter.supplierDispute": "Litige fournisseur", "merchant.ap.reconciliation.action.CONFIRM_MATCH": "Rapprochement confirmé", "merchant.ap.reconciliation.action.SPLIT_ALLOCATION": "Montant réparti", "merchant.ap.reconciliation.action.LEAVE_UNMATCHED": "Laissé non rapproché", "merchant.ap.reconciliation.action.ESCALATE": "Escaladé", "merchant.ap.reconciliation.action.REVERSE_MATCH": "Rapprochement annulé",
  "merchant.ap.reconciliation.allocationAmount": "Montant à répartir",
  "merchant.ap.reconciliation.loadMore": "Charger plus d’opérations",
  "merchant.ap.reconciliation.loadMoreMatches": "Charger les rapprochements antérieurs",
  "merchant.ap.reconciliation.entrySearch": "Rechercher une autre facture ouverte",
  "merchant.ap.reconciliation.search": "Rechercher",
  "merchant.ap.reconciliation.addEntry": "Ajouter",
  "merchant.ap.reconciliation.entrySearchError": "Impossible de charger les factures ouvertes.",
  "merchant.ap.reconciliation.loadMoreApprovals": "Charger plus d’approbations",
  "merchant.ap.reconciliation.escalationQueue": "Transmis pour examen complémentaire",
  "merchant.ap.reconciliation.loadMoreEscalations": "Charger les escalades précédentes",
  "merchant.ap.reconciliation.loadMoreInvoices": "Charger plus de factures",
  "loyalty.visitChanged": "Actualisez la page et ouvrez la visite en cours avant de modifier sa carte.",
  "loyalty.camera.starting": "Démarrage de la caméra…",
  "loyalty.camera.unsupported": "Ce navigateur ne permet pas le scan. Saisissez le numéro manuellement.",
  "loyalty.camera.permissionDenied": "Caméra indisponible. Vérifiez les autorisations ou saisissez le numéro manuellement.",
  "loyalty.camera.noCardFound": "Numéro de carte non reconnu.",
  "loyalty.camera.ambiguous": "Plusieurs numéros de carte détectés.",
  "loyalty.camera.selectCandidate": "Choisissez le bon numéro.",
  "merchant.ap.invalidAmount": "Saisissez un montant entier en unités monétaires mineures.",
  "merchant.dishes.menu.invalidPrice": "Le prix doit être un nombre positif ou nul.",
  "merchant.dishes.menu.invalidPreparationTime": "Le temps de préparation doit être un entier positif ou nul.",
  "merchant.dishes.menu.invalidTopPicks": "La quantité initiale doit être un entier positif ou nul.",
};

export default commonFr;
